import { AutocompleteInput } from '@src/shared/ui/inputs';
import { useTranslation } from 'react-i18next';

export default function TasksFilter() {
  const { t } = useTranslation();
  return (
    <AutocompleteInput
      onChange={() => {}}
      options={[]}
      placeholder={t('absence.tasks.filter_all_types', 'All types')}
      sx={{
        '& .MuiTextField-root': {
          margin: 0,
        },
      }}
    />
  );
}
